var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
!function (t, e) {
  exports = e();
}(self, () => (() => {
  "use strict";

  var t = {
      961: (t, e) => {
        /*
         * HSBasePlugin
         * @version: 2.4.1
         * @author: Preline Labs Ltd.
         * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
         * Copyright 2024 Preline Labs Ltd.
         */
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = function () {
          function t(t, e, s) {
            (this || _global).el = t, (this || _global).options = e, (this || _global).events = s, (this || _global).el = t, (this || _global).options = e, (this || _global).events = {};
          }
          return t.prototype.createCollection = function (t, e) {
            var s;
            t.push({
              id: (null === (s = null == e ? void 0 : e.el) || void 0 === s ? void 0 : s.id) || t.length + 1,
              element: e
            });
          }, t.prototype.fireEvent = function (t, e) {
            if (void 0 === e && (e = null), (this || _global).events.hasOwnProperty(t)) return (this || _global).events[t](e);
          }, t.prototype.on = function (t, e) {
            (this || _global).events[t] = e;
          }, t;
        }();
        e.default = s;
      },
      268: function (t, e, s) {
        /*
         * HSCarousel
         * @version: 2.4.1
         * @author: Preline Labs Ltd.
         * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
         * Copyright 2024 Preline Labs Ltd.
         */
        var i,
          n = (this || _global) && (this || _global).__extends || (i = function (t, e) {
            return i = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
            }, i(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function s() {
              (this || _global).constructor = t;
            }
            i(t, e), t.prototype = null === e ? Object.create(e) : (s.prototype = e.prototype, new s());
          }),
          o = (this || _global) && (this || _global).__assign || function () {
            return o = Object.assign || function (t) {
              for (var e, s = 1, i = arguments.length; s < i; s++) for (var n in e = arguments[s]) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
              return t;
            }, o.apply(this || _global, arguments);
          },
          r = (this || _global) && (this || _global).__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var l = function (t) {
          function e(e, s) {
            var i,
              n,
              r,
              l = t.call(this || _global, e, s) || this || _global,
              a = e.getAttribute("data-hs-carousel"),
              d = a ? JSON.parse(a) : {},
              c = o(o({}, d), s);
            return l.currentIndex = c.currentIndex || 0, l.loadingClasses = c.loadingClasses ? "".concat(c.loadingClasses).split(",") : null, l.loadingClassesRemove = (null === (i = l.loadingClasses) || void 0 === i ? void 0 : i[0]) ? l.loadingClasses[0].split(" ") : "opacity-0", l.loadingClassesAdd = (null === (n = l.loadingClasses) || void 0 === n ? void 0 : n[1]) ? l.loadingClasses[1].split(" ") : "", l.afterLoadingClassesAdd = (null === (r = l.loadingClasses) || void 0 === r ? void 0 : r[2]) ? l.loadingClasses[2].split(" ") : "", l.isAutoPlay = void 0 !== c.isAutoPlay && c.isAutoPlay, l.speed = c.speed || 4000, l.isInfiniteLoop = void 0 === c.isInfiniteLoop || c.isInfiniteLoop, l.isRTL = void 0 !== c.isRTL && c.isRTL, l.inner = l.el.querySelector(".hs-carousel-body") || null, l.slides = l.el.querySelectorAll(".hs-carousel-slide") || [], l.prev = l.el.querySelector(".hs-carousel-prev") || null, l.next = l.el.querySelector(".hs-carousel-next") || null, l.dots = l.el.querySelectorAll(".hs-carousel-pagination > *") || null, l.sliderWidth = l.inner.parentElement.clientWidth, l.touchX = {
              start: 0,
              end: 0
            }, l.init(), l;
          }
          return n(e, t), e.prototype.init = function () {
            var t,
              e,
              s = this || _global;
            this.createCollection(window.$hsCarouselCollection, this || _global), (this || _global).inner && (this.calculateWidth(), (this || _global).loadingClassesRemove && ("string" == typeof (this || _global).loadingClassesRemove ? (this || _global).inner.classList.remove((this || _global).loadingClassesRemove) : (t = (this || _global).inner.classList).remove.apply(t, (this || _global).loadingClassesRemove)), (this || _global).loadingClassesAdd && ("string" == typeof (this || _global).loadingClassesAdd ? (this || _global).inner.classList.add((this || _global).loadingClassesAdd) : (e = (this || _global).inner.classList).add.apply(e, (this || _global).loadingClassesAdd))), (this || _global).prev && (this || _global).prev.addEventListener("click", function () {
              s.goToPrev(), s.isAutoPlay && (s.resetTimer(), s.setTimer());
            }), (this || _global).next && (this || _global).next.addEventListener("click", function () {
              s.goToNext(), s.isAutoPlay && (s.resetTimer(), s.setTimer());
            }), (this || _global).dots && (this || _global).dots.forEach(function (t, e) {
              return t.addEventListener("click", function () {
                s.goTo(e), s.isAutoPlay && (s.resetTimer(), s.setTimer());
              });
            }), (this || _global).slides.length && (this.addCurrentClass(), (this || _global).isInfiniteLoop || this.addDisabledClass(), (this || _global).isAutoPlay && this.autoPlay()), (this || _global).inner && (this || _global).afterLoadingClassesAdd && setTimeout(function () {
              var t;
              "string" == typeof s.afterLoadingClassesAdd ? s.inner.classList.add(s.afterLoadingClassesAdd) : (t = s.inner.classList).add.apply(t, s.afterLoadingClassesAdd);
            }), (this || _global).el.classList.add("init"), (this || _global).el.addEventListener("touchstart", function (t) {
              s.touchX.start = t.changedTouches[0].screenX;
            }), (this || _global).el.addEventListener("touchend", function (t) {
              s.touchX.end = t.changedTouches[0].screenX, s.detectDirection();
            }), this.observeResize();
          }, e.prototype.observeResize = function () {
            var t = this || _global;
            new ResizeObserver(function () {
              return t.recalculateWidth();
            }).observe(document.querySelector("body"));
          }, e.prototype.calculateWidth = function () {
            var t = this || _global;
            (this || _global).inner.style.width = "".concat((this || _global).sliderWidth * (this || _global).slides.length, "px"), (this || _global).inner.style.transform = this.calculateTransform(), (this || _global).slides.forEach(function (e) {
              e.style.width = "".concat(t.sliderWidth, "px");
            });
          }, e.prototype.addCurrentClass = function () {
            var t = this || _global;
            (this || _global).slides.forEach(function (e, s) {
              s === t.currentIndex ? e.classList.add("active") : e.classList.remove("active");
            }), (this || _global).dots && (this || _global).dots.forEach(function (e, s) {
              s === t.currentIndex ? e.classList.add("active") : e.classList.remove("active");
            });
          }, e.prototype.addDisabledClass = function () {
            if (!(this || _global).prev || !(this || _global).next) return !1;
            0 === (this || _global).currentIndex ? ((this || _global).next.classList.remove("disabled"), (this || _global).prev.classList.add("disabled")) : (this || _global).currentIndex === (this || _global).slides.length - 1 ? ((this || _global).prev.classList.remove("disabled"), (this || _global).next.classList.add("disabled")) : ((this || _global).prev.classList.remove("disabled"), (this || _global).next.classList.remove("disabled"));
          }, e.prototype.autoPlay = function () {
            this.setTimer();
          }, e.prototype.setTimer = function () {
            var t = this || _global;
            (this || _global).timer = setInterval(function () {
              t.currentIndex === t.slides.length - 1 ? t.goTo(0) : t.goToNext();
            }, (this || _global).speed);
          }, e.prototype.resetTimer = function () {
            clearInterval((this || _global).timer);
          }, e.prototype.detectDirection = function () {
            var t = (this || _global).touchX,
              e = t.start,
              s = t.end;
            s < e && this.goToNext(), s > e && this.goToPrev();
          }, e.prototype.recalculateWidth = function () {
            (this || _global).sliderWidth = (this || _global).inner.parentElement.clientWidth, this.calculateWidth();
          }, e.prototype.calculateTransform = function () {
            var t = (this || _global).currentIndex * (this || _global).sliderWidth;
            return (this || _global).isRTL ? "translate(".concat(t, "px, 0px)") : "translate(-".concat(t, "px, 0px)");
          }, e.prototype.goToPrev = function () {
            0 === (this || _global).currentIndex && (this || _global).isInfiniteLoop ? ((this || _global).currentIndex = (this || _global).slides.length - 1, (this || _global).inner.style.transform = this.calculateTransform(), this.addCurrentClass()) : 0 !== (this || _global).currentIndex && ((this || _global).currentIndex -= 1, (this || _global).inner.style.transform = this.calculateTransform(), this.addCurrentClass(), this.addDisabledClass());
          }, e.prototype.goToNext = function () {
            (this || _global).currentIndex === (this || _global).slides.length - 1 && (this || _global).isInfiniteLoop ? ((this || _global).currentIndex = 0, (this || _global).inner.style.transform = this.calculateTransform(), this.addCurrentClass()) : (this || _global).currentIndex < (this || _global).slides.length - 1 && ((this || _global).currentIndex += 1, (this || _global).inner.style.transform = this.calculateTransform(), this.addCurrentClass(), this.addDisabledClass());
          }, e.prototype.goTo = function (t) {
            (this || _global).currentIndex = t, (this || _global).inner.style.transform = this.calculateTransform(), this.addCurrentClass(), (this || _global).isInfiniteLoop || this.addDisabledClass();
          }, e.getInstance = function (t, e) {
            var s = window.$hsCarouselCollection.find(function (e) {
              return e.element.el === ("string" == typeof t ? document.querySelector(t) : t);
            });
            return s ? e ? s : s.element : null;
          }, e.autoInit = function () {
            window.$hsCarouselCollection || (window.$hsCarouselCollection = []), document.querySelectorAll("[data-hs-carousel]:not(.--prevent-on-load-init)").forEach(function (t) {
              window.$hsCarouselCollection.find(function (e) {
                var s;
                return (null === (s = null == e ? void 0 : e.element) || void 0 === s ? void 0 : s.el) === t;
              }) || new e(t);
            });
          }, e;
        }(r(s(961)).default);
        window.addEventListener("load", function () {
          l.autoInit();
        }), window.addEventListener("resize", function () {
          if (!window.$hsCarouselCollection) return !1;
          window.$hsCarouselCollection.forEach(function (t) {
            t.element.recalculateWidth();
          });
        }), "undefined" != typeof window && (window.HSCarousel = l), e.default = l;
      }
    },
    e = {};
  var s = function s(i) {
    var n = e[i];
    if (void 0 !== n) return n.exports;
    var o = e[i] = {
      exports: {}
    };
    return t[i].call(o.exports, o, o.exports, s), o.exports;
  }(268);
  return s;
})());
export default exports;